import React, { useEffect, useState } from 'react';
import { Container, Card, Spinner, Alert } from 'react-bootstrap';
import api from '../../api/apiClient';
import LandingNavbar from './Navbar';

const PrivacyPolicyPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.privacy.getCurrent();
        if (response.data?.success) {
          setPolicy(response.data.data || null);
        } else {
          setError(response.data?.message || 'Failed to load Privacy Policy');
        }
      } catch (err) {
        const message = err.response?.data?.message || err.message;
        setError(message || 'Failed to load Privacy Policy');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacy();
  }, []);

  return (
    <div className="min-vh-100 d-flex flex-column bg-light">
      <LandingNavbar />
      
      <div className="flex-grow-1 pt-5 mt-5">
        <Container className="py-4">
          <Card className="shadow-sm">
            <Card.Body className="p-4 p-md-5">
              <h1 className="mb-4">Privacy Policy</h1>

              {loading && (
                <div className="text-center py-4">
                  <Spinner animation="border" />
                </div>
              )}

              {error && !loading && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}

              {!loading && !error && !policy && (
                <div className="text-muted">
                  No Privacy Policy has been published yet.
                </div>
              )}

              {!loading && !error && policy && (
                <>
                  <div className="text-muted mb-3">
                    Version {policy.version}{' '}
                    {policy.published_at && (
                      <>
                        (published on {new Date(policy.published_at).toLocaleDateString()})
                      </>
                    )}
                  </div>
                  <div 
                    className="policy-content"
                    dangerouslySetInnerHTML={{ __html: policy.content || '' }} 
                  />
                </>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>

      <footer className="bg-dark text-white py-4 mt-auto">
        <Container>
          <div className="text-center">
            <p className="mb-0">© {new Date().getFullYear()} Enable LXP. All rights reserved.</p>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;
